import { IStore } from '../index'

export const getStatusNetworkValue = (state: IStore) =>
  state.statusNetworkReducer
